/**
 * Для чего собрана статистика: аккаунт и дни периода. По ключу выгрузка
 * понимает, свои ли у неё цифры, — после смены аккаунта или периода
 * собранное раньше в отчёт уйти не должно.
 */
export function collectionKey(accountId: string, period: { from: Date; to: Date }): string {
  return `${accountId}|${day(period.from)}|${day(period.to)}`;
}

const pad = (n: number) => String(n).padStart(2, '0');
const day = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
